import { useRef } from "react";
import { useRouteMatch, useLocation } from "react-router-dom";
import qs from "qs";

export default function useQuery<T = any>() {
    const location = useLocation();
    const currentQuery = qs.parse(location.search, {
        ignoreQueryPrefix: true
    }) as unknown as T;

    const match = useRouteMatch();

    const queryRef = useRef<T>(currentQuery);

    if (match.path) {
        queryRef.current = currentQuery;
    }

    return match.path ? currentQuery : queryRef.current;
}
